import { TicketMessageItemArray } from './ticket.message.item';
import { TicketLogItemArray } from './ticket.log.item';

export enum PriorityTypes {
    Low = 0,
    Medium = 1,
    High = 2
}


export interface ITicketItem  {
    TicketID: number;
    AdminID: number;
    MemberID: number;
    TicketNR: string;
    Name: string;
    Email: string;
    Subject: string;
    Status: string;
    Priority: PriorityTypes;
    Urgency: string;
    DateTimeCreated: Date;
    DateTimeLastReply: Date;
    FirstMessage: string;
    HasNotes: boolean;
    Messages: TicketMessageItemArray;
    OriginalName: string;
    OriginalEmail: string;
    Logs: TicketLogItemArray;
    DepartmentID: number;
    MemberName: string;

}

export class TicketItem  implements ITicketItem {
    TicketID: number;
    AdminID: number;
    MemberID: number;
    TicketNR: string;
    Name: string;
    Email: string;
    Subject: string;
    Status: string;
    Priority: PriorityTypes;
    Urgency: string;
    HasNotes: boolean;
    DateTimeCreated: Date;
    DateTimeLastReply: Date;
    Messages: TicketMessageItemArray;
    FirstMessage: string;
    OriginalName: string;
    OriginalEmail: string;
    Logs: TicketLogItemArray = new TicketLogItemArray();
    DepartmentID: number;
    MemberName: string;
}
